(function () {
    'use strict';

    angular
        .module('componentVisualGuidelinesControllers')
        .controller('VisualGuidelinesComponentPickerPersonController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.pickerPerson = {};

        $scope.selectPerson = function (person) {
            $scope.pickerPerson.Person = person;
        }
    }
})();